import React from 'react'

import {Box, DialogTitle} from '@mui/material'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import {makeStyles} from 'tss-react/mui'

import {CloseButton} from '@progyny/components/Buttons'
import {useModalStore} from '@progyny/store/modalStore'

const useStyles = makeStyles()(() => ({
  closeButtonContainer: {
    width: '100%',
    textAlign: 'left',
  },
}))

const Modal = () => {
  const modalProps = useModalStore((state) => state.modalProps)
  const {open, onClose, children, title, ...rest} = modalProps

  const {classes} = useStyles()

  return (
    <Dialog open={open} onClose={onClose} {...rest}>
      {onClose && (
        <Box className={classes.closeButtonContainer}>
          <CloseButton onClick={onClose} />
        </Box>
      )}
      {title && <DialogTitle>{title}</DialogTitle>}
      <DialogContent>{children}</DialogContent>
    </Dialog>
  )
}

export default Modal
